<template>
  <div id="app">
    <notifications />
    <div id="preloader-active" v-show="!loading && !isLogin && loadInfoDone">
      <div class="preloader d-flex align-items-center justify-content-center">
        <div class="preloader-inner position-relative">
          <div class="preloader-circle"></div>
          <div class="preloader-img pere-text">
            <img src="@/assets/images/logo.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <template>
      <top-bar :loading.sync="loading" v-if="!isLogin"></top-bar>
      <main v-if="loadInfoDone & loading">
        <router-view />
      </main>
      <my-footer v-if="!isLogin"></my-footer>
    </template>
  </div>
</template>
<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import './assets/css/animate.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/flaticon.css';
import './assets/css/fontawesome-all.min.css';
import './assets/css/gijgo.css';
import './assets/css/magnific-popup.css';
// import "./assets/css/main.css"
import './assets/css/nice-select.css';
import './assets/css/owl.carousel.min.css';
import './assets/css/responsive.css';
import './assets/css/slick.css';
import './assets/css/slicknav.css';
import './assets/css/style.css';
import './assets/css/ticker-style.css';
import './assets/css/themify-icons.css';
import '@/assets/css/app.css';

import User from '@/common/api/user';
import TopBar from './components/TopBar';
import Clock from './components/Clock';
import MyFooter from './components/Footer';
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import VModal from 'vue-js-modal';
import { destroyToken, getInfo } from '@/common/jwt';
import { SET_AUTH } from '@/store/actions.type';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import gallery from 'img-vuer';
import Paginate from 'vuejs-paginate';

Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: true, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true // preload images in the same group, default true
});
Vue.use(VueSweetalert2);
Vue.use(VModal, { dynamicDefaults: { height: 'auto' } });
Vue.use(Loading, {
  color: '#FC3F00',
  width: 48,
  height: 48
});
Vue.component('paginate', Paginate);

export default {
  components: { TopBar, MyFooter, Clock },
  name: 'App',
  data() {
    return {
      isLogin: false,
      loading: false,
      loadInfoDone: false
    };
  },
  created() {
    if (this.$route.path === '/login') {
      this.isLogin = true;
      this.loadInfoDone = true;
      this.loading = true;
    } else {
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      let info = getInfo();
      let obj = JSON.parse(info);
      if (info && !this.isLogin) {
        const loader = this.$loading.show();
        console.log('loading');
        User.get(obj.id)
          .then(({ data }) => {
            obj.name = data.Data.HoTen;
            obj.email = data.Data.Email;
            obj.permissions = data.Data.ArrayPermissionId;
            this.$store.dispatch(SET_AUTH, obj).then();
            this.loadInfoDone = true;
          })
          .catch((error) => {
            console.log(error);
            destroyToken();
          })
          .finally(() => {
            loader.hide();
          });
      } else {
        this.loadInfoDone = true;
      }
    }
  }
};
</script>

<style>
a {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue